exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".file-control-container[data-v-4837d310]{flex-basis:0}.file-control[data-v-4837d310]{padding:.25em .5em;border-left:1px solid #dee2e6;border-right:1px solid #dee2e6;cursor:pointer}.file-control__text[data-v-4837d310]{text-transform:uppercase;font-size:.9em}.file-control__icon[data-v-4837d310]{margin-left:.5em}.file-control[data-v-4837d310]:hover{background:rgba(0,0,0,.1)}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-4837d310","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/file-elements/file-control.vue
// module id = 127
// module chunks = 0